import { VerificationCodeField } from '@hotjar/webapp/components/VerificationCodeField';
import * as React from 'react';
import type { ReactElement } from 'react';
import styled from '@emotion/styled';
import { Text, tokens } from '@hotjar/hotsauce';

const StyledError = styled(Text)`
  display: block;
  margin-top: ${tokens.spacer.x1};
`;

interface MfaCodeFieldProps {
  error: string | null;
  onChange: (otp: string) => void;
  onInput: (code: number[]) => void;
}

export const MfaCodeVerification = ({
  error,
  onChange,
  onInput,
}: MfaCodeFieldProps): ReactElement => {
  return (
    <>
      <VerificationCodeField
        justify="flex-start"
        hasError={!!error}
        onChange={onChange}
        onInput={onInput}
        data-testid="mfa-otp-input"
      />
      {!!error && (
        <StyledError textColor="text_error" data-testid="mfa-otp-error">
          {error}
        </StyledError>
      )}
    </>
  );
};
